import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { BootstrapService } from 'app/00_modules/core/services/bootstrap.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { AppEventType } from './00_modules/core/common/event.type';
import { EventQueueService } from './00_modules/core/services/eventQueue.service';
import { HealthService } from './services/health.service';
import { UiFacade } from './store/facade/ui.facade';
import { AppContextFactory } from './00_modules/contextbar/services/app-context/app-context.factory';
import { InfoWindowDialogService } from './00_modules/shared/services/info-window-dialog.service';
import { ApplicationHeaderComponent } from './core/header/application-header/application-header.component';
import { ContextHeaderComponent } from './core/header/context-header/context-header.component';
import { ContextNavigationComponent } from './core/header/context-navigation/context-navigation.component';
import { SubHeaderComponent } from './core/header/sub-header/sub-header.component';
import { AsyncPipe } from '@angular/common';
import { CriticalErrorComponent } from './00_modules/shared/components/critical-error/critical-error.component';
import { LoadingOverlayComponent } from './00_modules/shared/components/loading-overlay/loading-overlay.component';
import { NavigationScrollService } from './services/navigation-scroll.service';
import { AiChatbotDockComponent } from './00_modules/ai-chatbot/components/ai-chatbot-dock/ai-chatbot-dock.component';

@Component({
    selector: 'je-root',
    templateUrl: './app.component.html',
    imports: [
        ApplicationHeaderComponent,
        ContextHeaderComponent,
        ContextNavigationComponent,
        SubHeaderComponent,
        RouterOutlet,
        CriticalErrorComponent,
        LoadingOverlayComponent,
        AsyncPipe,
        AiChatbotDockComponent,
    ],
})
export class AppComponent implements OnInit, OnDestroy {
    public criticalError$: Observable<boolean>;
    public isBusy: boolean;
    public environment = environment;
    private destroy$: Subject<boolean> = new Subject<boolean>();
    public appContext$ = this.appContextFactory.context$.pipe(takeUntil(this.destroy$));

    constructor(
        private router: Router,
        private healthService: HealthService,
        private bootstrapService: BootstrapService,
        private eventQueue: EventQueueService,
        private uiFacade: UiFacade,
        private infoWindowDialogService: InfoWindowDialogService,
        private appContextFactory: AppContextFactory,
        private navigationScrollService: NavigationScrollService,
    ) {
        this.isBusy = true;
        this.criticalError$ = this.uiFacade.isCriticalError$;
    }

    public ngOnInit(): void {
        this.bootstrapService.Init();
        this.healthService.Start();

        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.isBusy = true;
            } else if (event instanceof NavigationEnd) {
                this.isBusy = false;
                this.navigationScrollService.resetScrollPositionOnNavigation(event.urlAfterRedirects);
            } else if (event instanceof NavigationCancel) {
                this.isBusy = false;
            }
        });

        this.eventQueue.on(AppEventType.ShowLoading).subscribe(() => (this.isBusy = true));
        this.eventQueue.on(AppEventType.HideLoading).subscribe(() => (this.isBusy = false));

        this.infoWindowDialogService.registerForNotification();
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
